export const HOST = ['https://ams-auth-us-test.tigerbrokers.net/user', 'https://oauth.tradeup.com/user'];

export const API = {
    // 针对个人中心提供的专门接口: https://tigertech.feishu.cn/wiki/wikcnVaEGJoXs5JxX6hKKaihN8L#
    webUserStatus: '/api/v2/web/user/status',

    // https://apidocs.tigerfintech.com/repository/83/api/master/APIs/profile.json#/operations/post-api-v1-user-cancellation-apply
    // @huangcong
    closeAccount: '/api/v1/user/cancellation', // 是否已经提交注销请求了
    closeAccountApply: '/api/v1/user/cancellation/apply' // 提交注销账号申请
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    // cg经常错误配置
    const cfg = CG_API['oauth-global']?.GLOBAL || (CG_API['oauth-global'] as any)?.COMMON;

    if (cfg) {
        HOST.fill(`${cfg}/user`);
    }
}
